<template>
<div class="page">
  
   <headerPreview v-if="is_preview"></headerPreview>
   <Headers v-else ></Headers>
   <div class="con">
      <div class="listarea">
        <div class="listheader">
          <div class="titlebox">
            <img src="../../../assets/collect/titleicon1.png" alt="" class="icon" >
            <div class="listtitle">{{city.title}}</div>
          </div>
          <div class="totalheader">
                <div class="catetitle cate-jy">经营性用地</div>
                <div v-if="city.total_city_land==0 || city.total_city_land==null" class="infoitem">正在维护中...</div>
                <template v-else>
                  <div class="infoitem">总宗数： <span class="unit">{{city.total_city_land}}</span> <span class="unitshow" >宗</span> </div>
                  <div class="infoitem">总面积：<span class="unit">{{city.total_city_land_acreagemu}}</span> <span class="unitshow" >亩</span> </div>
                </template>
            </div>
           <div class="totalheader">
                <div class="catetitle cate-gy">产业用地</div>
                <div v-if="city.total_city_land_gy==0 || city.total_city_land_gy==null" class="infoitem">正在维护中...</div>
                <template v-else>
                  <div class="infoitem">总宗数： <span class="unit">{{city.total_city_land_gy}}</span> <span class="unitshow" >宗</span> </div>
                  <div class="infoitem">总面积：<span class="unit">{{city.total_city_land_acreagemu_gy}}</span> <span class="unitshow" >亩</span> </div>
                </template>
            </div>
        </div>
        <div class="list">
            <div v-for="item in city.list" :key="item.id" class="listitem" @click="todetail(item.city_id)">
              <img  :src="item.cover_url" alt="" class="listitemimg">
              <div class="listitemtitle">{{item.name}}</div>
              <div class="listitemline">{{item.intro}}</div>
               <div class="unitinfo">
                 <div  class="catetitle" >经营性用地</div>
                <div class="infoitem">宗数: <span class="unit">{{item.total}}</span> <span class="unitshow" >宗</span> </div>
                <div class="infoitem">总面积:<span class="unit">{{item.totalAcreagemu}}</span><span class="unitshow">亩</span> </div>
               </div>
               <div class="gybox">
                <div  class="catetitle" >产业用地</div>
                <div v-if="item.total_gy==0 || item.total_gy==null" class="infoitem"> 正在维护中...</div>
                <div v-else class="unitinfo" >
                  <div  class="infoitem">宗数: <span class="unit">{{item.total_gy}}</span> <span class="unitshow" >宗</span> </div>
                    <div class="infoitem">总面积:<span class="unit">{{item.totalAcreagemu_gy}}</span><span class="unitshow">亩</span> </div>
                </div>
               </div>
            </div>

        </div>
        
      </div>
      <div class="listarea">
        <div class="listheader">
          <div class="titlebox">
            <img src="../../../assets/collect/titleicon1.png" alt="" class="icon" >
            <div class="listtitle">{{district.title}}</div>
          </div>
          <div class="totalheader">
               <div class="catetitle cate-jy">经营性用地</div>
                <div v-if="district.total_second_city_land==0 || district.total_second_city_land==null" class="infoitem">正在维护中...</div>
                <template v-else>
                  <div class="infoitem">总宗数：<span class="unit">{{district.total_second_city_land}}</span> <span class="unitshow" >宗</span> </div>
                  <div class="infoitem">总面积：<span class="unit">{{district.total_second_city_land_acreagemu}}</span> <span class="unitshow" >亩</span> </div>
                </template>
            </div>
             <div class="totalheader">
               <div class="catetitle cate-gy">产业用地</div>
                <div v-if="district.total_second_city_land_gy==0 || district.total_second_city_land_gy==null" class="infoitem">正在维护中...</div>
                <template v-else>
                  <div class="infoitem">总宗数：<span class="unit">{{district.total_second_city_land_gy}}</span> <span class="unitshow" >宗</span> </div>
                  <div class="infoitem">总面积：<span class="unit">{{district.total_second_city_land_acreagemu_gy}}</span> <span class="unitshow" >亩</span> </div>
                </template>
            </div>
        </div>
        <div class="list">
            <div v-for="item in district.list" :key="item.id" @click="todetail(item.city_id)"  class="listitem">
              <img :src="item.cover_url" alt="" class="listitemimg">
              <div class="listitemtitle">{{item.name}}</div>
              <div class="listitemline">{{item.intro}}</div>
              <div class="unitinfo">
                <div  class="catetitle" >经营性用地</div>
                 <div class="infoitem">宗数: <span class="unit">{{item.total}}</span> <span class="unitshow" >宗</span> </div>
                <div class="infoitem">总面积:<span class="unit">{{item.totalAcreagemu}}</span><span class="unitshow">亩</span> </div>
               </div>
               <div class="gybox">
                <div  class="catetitle" >产业用地</div>
                <div v-if="item.total_gy==0 || item.total_gy==null" class="infoitem"> 正在维护中...</div>
                <div v-else class="unitinfo" >
                  <div  class="infoitem">宗数: <span class="unit">{{item.total_gy}}</span> <span class="unitshow" >宗</span> </div>
                    <div class="infoitem">总面积:<span class="unit">{{item.totalAcreagemu_gy}}</span><span class="unitshow">亩</span> </div>
                </div>
               </div>
            </div>
        </div>
        
      </div>

     

   </div>
   <div class="ad"  @click.prevent="toad">
			<i  class="close el-icon-circle-close" @click.stop="colsedad"></i>
			<img class="adimg" :src="ad.pic_url" alt="">		
		</div>

      <div style="width: 100%; height: 100px; display: flex; justify-content: center;align-items: center;">
        <div style=" bottom:-30px;margin-top:30px;">技术支持@土拍网   
           <a style="text-decoration:none;color:#666;" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备10200322号-1 </a>许可证编号  
           <a style="text-decoration:none;color:#666;" href="https://www.chinatupai.com//#/icp">苏B2-20200446</a> </div>
      </div>
</div>
</template>
<script>
import {allList} from '@/api/website/collect'
import Headers from '@/components/collect/header'
import headerPreview from '@/components/collect/headerPreview'

import {ad} from '@/api/website/tradesystem.js'

export default {
  components:{Headers,headerPreview},
  props:{
    is_preview:0
  },
  mounted() {
    this.getList()
    this.getad()
  },

  data() {
    return{
      ad:{},
      city: {
        title:'省会/地级市',
        list:[
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          }, {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
           {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
        ]
      },
      district:{
        title:'区/县/市',
        list:[
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },{
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          }
        ]
      }
    }
  },

  methods:{


		toad(){
			window.open(this.ad.link)
		},
    
    getad(){
			ad().then(res=>{
				 this.ad = res.data
			})

		},

    todetail(id){
      if(this.is_preview){
         this.$router.push({path:'/preview/detail/'+id,})
      }else{
         this.$router.push({path:'/collect/detail/'+id,})
      }
     
    },

    getList(){
      const params = {
        is_view:this.is_preview
      }
      allList(params).then(res=>{
        this.city = res.data.city
        this.district = res.data.district
      })
    }
    
  },
  data() {
    return{
      city: {
        title:'省会/地级市',
        list:[
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          }, {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
           {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
        ]
      },
      district:{
        title:'区/县/市',
        list:[
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },{
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          },
          {
            name:'南京市',
            intro:'创新名城 美丽古都'
          }
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.gybox{
  display: flex;
  align-items: center;
}
 .catetitle{
    margin-right:10px;
    width: 60px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-ideograph;
    height: 24px;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
  }
.unitinfo{
  display: flex;
  align-items: center;
  .infoitem{
    margin-right:20px;
    font-weight: 600;
    height: 24px;
    line-height: 24px;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
  .unit{
    width: 100%;
    color:#e40e0ed7;
    font-weight: bold;
    
  }
  .unitshow{
    font-weight: 500;
  }
}

.page{
  width: 100%;
  height: 100%;
  background: linear-gradient( 180deg, #DFF4F5 0%, #F7FCFC 76%, #FEFEFE 100%);

}


.con{
  width: 100%;
  height: 100%;

  padding-bottom:100px;
  background: url('../../../assets/collect/bottombg1.png') no-repeat left 0 bottom 0;
}
.listarea{
  
  width:1200px;
  height: 100%;
  margin:0 auto;
  margin-top:38px;
  .listheader{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url(../../../assets/collect/listtitle.jpg) no-repeat;
    .titlebox{
      width: 100%;
  
      display: flex;
      align-items: center;
      justify-content: center;
 
      .icon{
        width:38px;
        height:38px;
        
      }
      .listtitle{
        height: 40px;
        font-weight: 500;
        font-family: FZQingKeBenYueSongS-R-GB, FZQingKeBenYueSongS-R-GB;
        font-weight: 400;
        font-size: 30px;
        line-height:38px;
        text-shadow: 0px 4px 4px rgba(0,0,0,0.25);
        color:#fff;
        margin-left:15px;
    //  background: red;
 
      }
    }
    .totalheader{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      // 两行使用同一宽度，保证列对齐；父容器居中显示整体
      width: 320px;
      // min-height: 22px;
      gap: 4px;
      margin: 1px 0;

      .catetitle{
        // 表头“经营性用地/产业用地”两端对齐（单行）
        width: 80px;
        margin-right: 6px;
        text-align: justify;
        text-align-last: justify;
        text-justify: inter-ideograph;
        height: 18px;
        line-height: 18px;
        font-size: 14px;
        flex: 0 0 80px;
      }
      .cate-jy{
        color: #fff;
        font-weight: 700;
      }
      .cate-gy{
        color: #fff;
        font-weight: 700;
      }

        .infoitem{
          min-width:94px;
          font-size:14px;
          font-weight: 600;
          color:#fff;
          display: flex;
          align-items: center;
          height: 18px;
          line-height: 18px;
          padding:0 6px;
          white-space: nowrap;
        }
        .unit{
          width: 100%;
          color:#e40e0ed7;
          font-weight: bold;
          color:#fff;
        }
        .unitshow{
           font-size:14px;
            font-weight: 500;
            color:#fff;
        }
    }
  } 
  .list{
  width: 1200px;
  background: rgba(255,255,255,0.8);
  box-shadow: 0px 4px 12px 0px rgba(179,211,198,0.5);
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap; /* 默认值，不移除换行 */
  padding-bottom:30px;

  .listitem{
    margin-top:15px;
    width: 395px;
    padding-left:20px;
    box-sizing: border-box;
    padding-right:5px;
    // background:red;
    display: flex;
    flex-direction: column;
    align-items:flex-start ;
    justify-content:flex-start;
    cursor: pointer;

  .listitemimg{
    width: 370px;
    height: 212px;
    border-radius: 0px 0px 0px 0px;
  }
  .listitemtitle{
 
    height: 26px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .listitemline{
    width:100%;
      height: 22px;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 14px;
      color: #565656;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   
  }
  .listitembtn{
    width: 100px;
    height: 30px;
    background: #009688;
  }
}
}

  
}
.quxianshi{
  margin-top:59px;
}

.ad{
	z-index:2000;
	position: fixed;
	left:10px;
	bottom: 10px;
	width:200px;
	height:150px;
	.adimg{
		width:200px;
		height:150px;
	}
	.close{
		z-index:2001;
		position: absolute;
		top:10px;
		right:10px;
		font-size:20px;
		// color:#fff;
		cursor: pointer;

	}
}


</style>